import React, { Suspense, useReducer, useState, useEffect } from 'react'
import { Breadcrumb, BreadcrumbItem, Button, Link, TileGroup, RadioTile, Tag, Search } from 'carbon-components-react';
import { Tabs, Tab } from 'carbon-components-react';
import TimeFilter from '../ManageAutomationPage/Alerts/TimeFilter';
import moment from 'moment';
import ProcessOwner from "../../assets/image/Process_owner.svg";
import AutomationCoE from "../../assets/image/Automation_CoE.svg";
import AOCCSupervisor from "../../assets/image/AOCC_supervisor.svg";
import DashboardFilters from './DashboardFilters';
import { FilterEdit32, Close32 } from '@carbon/icons-react';
import callGetApi from "../../requests/GetRequests";
import * as Constants from '../../requests/URLConstants';
import { getNewTimeRange } from '../ManageAutomationPage/Alerts/TimeFilterUtil';
import callPostApi from "../../requests/PostRequests";
import ExecutionPerformance from './ExecutionPerformanceDashboard/ExecutionPerformance';
import IncidentManagement from './IncidentManagementDashboard/IncidentManagement';
import SLACompliance from './SLADashboard/SLACompliance';
import QueueEfficiency from './QueuePerformanceDashboard/QueuePerformance';
import AlertManagement from './AlertManagementDashboard/AlertManagement';
import QueueManagement from './QueueManagementDashboard/QueueManagement';
import CapacityManagement from './CapacityManagementDashboard/CapacityManagement';
import UllCapacityManagement from './CapacityManagementDashboard/UllCapacityManagement';
import SchedulingEfficiency from './SchedulingEfficiencyDashboard/SchedulingEfficiency';
import Remediation from './RemediationDashboard/Remediation';
import BotPerformance from './BotPerformance/BotPerformance';
import AutomationTrustIndex from './AutomationTrustIndexDashboard/AutomationTrustIndex';
import Juniper from './JuniperDashboard/Juniper';
import ProductivityMetrics from './ProductivityMetricsDashboard/ProductivityMetrics';
import AutomationSchedulingEfficiency from './AutomationSchedulingEfficiency/AutomationSchedulingEfficiency';
import * as config from "../../config/Constants";
import dashboardAccessConfig from "./config/dashboardAccessConfig";
import dashboardAccessConfigUll from "./config/dashboardAccessConfigUll";
import BusinessViewValueRealization from './BusinessView/BusinessViewValueRealization';
import BpmnDiagram from '../Bpmn/BpmnDiagram';
import * as DashboardConstants from './DashboardConstants';
import ULLAutomationTrustIndex from './AutomationTrustIndexDashboard/ULLAutomationTrustIndex';
import AutomationBusiness from './AutomationBusinessCatalogue/AutomationBusiness';
import SearchComponent from '../../common/SearchComponent';
import SearchBar from "material-ui-search-bar";
import * as workspaces from "../../config/WorkspaceConstants";
import BotPerformanceULL from './BotPerformance/BotPerformanceULL';
import UsageStats from './UsageStatsDashboard/UsageStats';

require("./_header-panel.scss");

const HeaderPanel = (props) => {

    let roles = JSON.parse(localStorage.getItem('roles'));
    //console.log("roles", roles );
    const accesibleDashboards = extractRoles(roles);

    const [timeFilterSelections, setTimeFilterSelections] = useState({});
    const [showFilters, setShowFilters] = useState(false);
    const [alertFilterData, alertFilterDispatch] = useReducer(alertFilterDataReducer, { clients: [] });
    const [dashboardFilterSelectionsAutomation, setdashboardFilterSelectionsAutomation] = useState({ 'franchise': [], 'client': [], 'technology': [], 'deployment_model': [], 'geo': [], "competency": [], 'priority': [], 'status': [], 'assignee': [], 'assignee_email': [], 'assigned_group': [], 'incident_status': [], 'buisness_component': [], 'automata_state': [], 'itemStatus_A1': [], 'queue_name': [], 'job_id': [], 'automata_name': [], 'automata_activity_name': [], 'resource': [], 'bot_id': [], 'assignment_group': [], 'process_name': [], "remediation_type": [] });
    const [dashboardFilterSelectionsSAP, setdashboardFilterSelectionsSAP] = useState({ 'franchise': [], 'client': [], 'priority': [], 'assigned_group': [], 'incident_status': [], 'assignment_group': [] });
    const [disabledSelects, setDisabledSelects] = useState({ 'client-select': true });
    let user = JSON.parse(localStorage.getItem('user'));
    const [userPrefs, setUserPrefs] = useState(null);
    const [showProcessOwnerDashboardList, setShowProcessOwnerDashboardList] = useState(false);
    const [showAOCCSupervisorDashboardList, setShowAOCCSupervisorDashboardList] = useState(false);
    const [showAutomationCOEDashboardList, setShowAutomationCOEDashboardList] = useState(false);
    const [isBackgroundProcessOwnerSelected, setBackgroundProcessOwner] = useState(false);
    const [isBackgroundAOCCSupervisorSelected, setBackgroundAOCCSupervisor] = useState(false);
    const [isBackgroundAutomationCOESelected, setBackgroundAutomationCOE] = useState(false);
    const [showExecutionDashboard, setExecutionDashboard] = useState(false);
    const [showSLACompliance, setSLACompliance] = useState(false);
    const [showIncidentManagement, setIncidentManagement] = useState(false);
    const [showQueueEfficiency, setQueueEfficiency] = useState(false);
    const [showQueueManagement, setQueueManagement] = useState(false);
    const [showCapacityManagement, setCapacityManagement] = useState(false);
    const [selectedDashboard, setSelectedDashboard] = useState(accesibleDashboards[0]);
    const [selectedFranchiseCount, setSelectedFranchiseCount] = useState();
    const [selectedClientCount, setSelectedClientCount] = useState();
    const [selectedTechnologyCount, setSelectedTechnologyCount] = useState();
    const [selectedDeploymentModelCount, setSelectedDeploymentModelCount] = useState();
    const [selectedGeoCount, setSelectedGeoCount] = useState();
    const [selectedCompetencyCount, setSelectedCompetencyCount] = useState();
    const [selectedPriorityCount, setSelectedPriorityCount] = useState();
    const [selectedStatusCount, setSelectedStatusCount] = useState();
    const [selectedAssigneeCount, setSelectedAssigneeCount] = useState();
    const [workspace, setWorkspace] = useState(props.workspace);
    const [preferencesChanged, setPreferencesChanged] = useState(false);
    const [selectedJobIDCount, setSelectedJobIDCount] = useState();
    const [selectedIncidentStatusCount, setSelectedIncidentStatusCount] = useState();
    const [selectedQueueNameCount, setSelectedQueueNameCount] = useState();
    const [selectedAutomataStateCount, setSelectedAutomataStateCount] = useState();
    const [selectedAssignedGroupCount, setSelectedAssignedGroupCount] = useState();
    const [selectedAssigneeEmailCount, setSelectedAssigneeEmailCount] = useState();
    const [selectedAssignmentGroupCount, setSelectedtAssignmentGroupCount] = useState();
    const [selectedAutomataActivityNameCount, setSelectedAutomataActivityNameCount] = useState();
    const [selectedAutomataNameCount, setSelectedAutomataNameCount] = useState();
    const [selectedBusinessComponentCount, setSelectedBusinessComponentCount] = useState();
    const [selectedItemStatusA1Count, setSelectedItemStatusA1Count] = useState();
    const [selectedResourceCount, setSelectedResourceCount] = useState();
    const [selectedBotIdCount, setSelectedBotIdCount] = useState();
    const [selectedProcessNameCount, setSelectedProcessNameCount] = useState();
    const [selectedKpi, setSelectedKpi] = useState(DashboardConstants.ROI);
    const [selectedRemediationTypeCount, setSelectedRemediationTypeCount] = useState();

    function extractRoles(roles) {

        let configToPick;
        if (config.URL.includes(config.unilever)) {
            configToPick = dashboardAccessConfigUll;
        } else {
            configToPick = dashboardAccessConfig;
        }

        //console.log("config",configToPick);
        // if (config.URL.includes(config.unilever)) {
        let accessibleDashbords = [];
        for (let i = 0; i < roles.length; i++) {
            if (configToPick[roles[i]]) {
                accessibleDashbords.push(...configToPick[roles[i]].dashboards);
            }

        }
        return accessibleDashbords;
        // } else {
        //     return dashboardAccessConfig['Dashboard_Admin'].dashboards;
        // }

    };

    useEffect(() => {

        // extractRoles(roles);
        getUserPreferences(user.username);
        if (workspace === workspaces.automation_ops) {
            callGetApi(Constants.GETALERTSFILTERDATAURL, { 'Content-Type': 'application/json' })
                .then(resp => {
                    if (resp.aggregations.franchises) {
                        let franchiseList = [];
                        resp.aggregations.franchises.buckets.forEach(element => {
                            let franchise = {};
                            franchise.name = element.key;
                            franchiseList.push(franchise);
                        });
                        alertFilterDispatch({ type: "add_franchise", item: franchiseList });
                    }

                    if (resp.aggregations.technologies) {
                        let technologiesList = [];
                        resp.aggregations.technologies.buckets.forEach(element => {
                            let technology = {};
                            technology.name = element.key;
                            technologiesList.push(technology);
                        });
                        alertFilterDispatch({ type: "add_technologies", item: technologiesList });
                    }

                    if (resp.aggregations.deployment_models.buckets) {
                        let deployment_modelsList = [];
                        resp.aggregations.deployment_models.buckets.forEach(element => {
                            let deployment_model = {};
                            deployment_model.name = element.key;
                            deployment_modelsList.push(deployment_model);
                        });
                        alertFilterDispatch({ type: "add_deployment_models", item: deployment_modelsList });
                    }

                    if (resp.aggregations.geos.buckets) {
                        let geosList = [];
                        resp.aggregations.geos.buckets.forEach(element => {
                            let geo = {};
                            geo.name = element.key;
                            geosList.push(geo);
                        });
                        alertFilterDispatch({ type: "add_geos", item: geosList });
                    }

                    if (resp.aggregations.competencies.buckets) {
                        let competenciesList = [];
                        resp.aggregations.competencies.buckets.forEach(element => {
                            let competency = {};
                            competency.name = element.key;
                            competenciesList.push(competency);
                        });
                        alertFilterDispatch({ type: "add_competencies", item: competenciesList });
                    }

                    if (resp.aggregations.priorities.buckets) {
                        let prioritiesList = [];
                        resp.aggregations.priorities.buckets.forEach(element => {
                            let priority = {};
                            priority.name = element.key;
                            prioritiesList.push(priority);
                        });
                        alertFilterDispatch({ type: "add_priorities", item: prioritiesList });
                    }

                    if (resp.aggregations.assigned_to.buckets) {
                        let assignedList = [];
                        resp.aggregations.assigned_to.buckets.forEach(element => {
                            let assigned = {};
                            assigned.name = element.key;
                            assignedList.push(assigned);
                        });
                        alertFilterDispatch({ type: "add_assignee", item: assignedList });
                    }

                    if (resp.aggregations.assigned_to_user_id.buckets) {
                        let assignedEmailList = [];
                        resp.aggregations.assigned_to_user_id.buckets.forEach(element => {
                            let assignedEmail = {};
                            assignedEmail.name = element.key;
                            assignedEmailList.push(assignedEmail);
                        });
                        alertFilterDispatch({ type: "add_assignee_email", item: assignedEmailList });
                    }

                    if (resp.aggregations.automata_state.buckets) {
                        let automataStateList = [];
                        resp.aggregations.automata_state.buckets.forEach(element => {
                            let automataState = {};
                            automataState.name = element.key;
                            automataStateList.push(automataState);
                        });
                        alertFilterDispatch({ type: "add_automata_state", item: automataStateList });
                    }

                    if (resp.aggregations.busn_component_name.buckets) {
                        let busnComponentList = [];
                        resp.aggregations.busn_component_name.buckets.forEach(element => {
                            let busnComponent = {};
                            busnComponent.name = element.key;
                            busnComponentList.push(busnComponent);
                        });
                        alertFilterDispatch({ type: "add_busn_component", item: busnComponentList });
                    }

                    if (resp.aggregations.status.buckets) {
                        let statusList = [];
                        resp.aggregations.status.buckets.forEach(element => {
                            let status = {};
                            status.name = element.key;
                            statusList.push(status);
                        });
                        alertFilterDispatch({ type: "add_status", item: statusList });
                    }

                    if (resp.aggregations.automata_activity_name.buckets) {
                        let automata_nameList = [];
                        resp.aggregations.automata_activity_name.buckets.forEach(element => {
                            let automata_name = {};
                            automata_name.name = element.key;
                            automata_nameList.push(automata_name);
                        });
                        alertFilterDispatch({ type: "add_automata_activity_name", item: automata_nameList });
                    }

                    if (resp.aggregations.resource.buckets) {
                        let resourceList = [];
                        resp.aggregations.resource.buckets.forEach(element => {
                            let resource_name = {};
                            resource_name.name = element.key;
                            resourceList.push(resource_name);
                        });
                        alertFilterDispatch({ type: "add_resource", item: resourceList });
                    }
                    if (resp.aggregations.bot_id.buckets) {
                        let botIdList = [];
                        resp.aggregations.bot_id.buckets.forEach(element => {
                            let bot_id_name = {};
                            bot_id_name.name = element.key;
                            botIdList.push(bot_id_name);
                        });
                        alertFilterDispatch({ type: "add_bot_id", item: botIdList });
                    }
                    if (resp.aggregations.process_name.buckets) {
                        let processNameList = [];
                        resp.aggregations.process_name.buckets.forEach(element => {
                            let process_name_name = {};
                            process_name_name.name = element.key;
                            processNameList.push(process_name_name);
                        });
                        alertFilterDispatch({ type: "add_process_name", item: processNameList });
                    }
                    if (resp.aggregations.remediation_type.buckets) {
                        let remediationTypeList = [];
                        resp.aggregations.remediation_type.buckets.forEach(element => {
                            let remediation_type = {};
                            remediation_type.name = element.key;
                            remediationTypeList.push(remediation_type);
                        });
                        alertFilterDispatch({ type: "add_remediation_type", item: remediationTypeList });
                    }

                }).catch((error) => {
                    console.error('Error:', error);
                });
        }


        callGetApi(Constants.GETQUEUEPERFORMANCEFLTERDATA, { 'Content-Type': 'application/json' })
            .then(resp => {
                //console.log('response', resp);

                if (resp.aggregations.queue_name) {
                    let queue_nameGroups = [];
                    resp.aggregations.queue_name.buckets.forEach(element => {
                        let queue_nameGroup = {};
                        queue_nameGroup.name = element.key;
                        queue_nameGroups.push(queue_nameGroup);
                    });
                    alertFilterDispatch({ type: "add_queue_nameGroups", item: queue_nameGroups });
                }

                if (resp.aggregations.job_id) {
                    let job_idList = [];
                    resp.aggregations.job_id.buckets.forEach(element => {
                        let job_id = {};
                        job_id.name = element.key;
                        job_idList.push(job_id);
                    });
                    alertFilterDispatch({ type: "add_job_id", item: job_idList });
                }
                if (resp.aggregations.itemStatus_A1) {
                    let itemStatus_A1List = [];
                    resp.aggregations.itemStatus_A1.buckets.forEach(element => {
                        let itemStatus_A1 = {};
                        itemStatus_A1.name = element.key;
                        itemStatus_A1List.push(itemStatus_A1);
                    });
                    alertFilterDispatch({ type: "add_itemStatus_A1", item: itemStatus_A1List });
                }
                if (resp.aggregations.automata_name) {
                    let automata_name_List = [];
                    resp.aggregations.automata_name.buckets.forEach(element => {
                        let automata_name = {};
                        automata_name.name = element.key;
                        automata_name_List.push(automata_name);
                    });
                    alertFilterDispatch({ type: "add_automata_name", item: automata_name_List });
                }

            }).catch((error) => {
                console.error('Error:', error);
            });

        callGetApi(Constants.GETSERVICEINDEXFILTERDATAURL, { 'Content-Type': 'application/json' })
            .then(resp => {
                //console.log('response', resp);

                if (resp.aggregations.assignment_group) {
                    let assignmentGroups = [];
                    resp.aggregations.assignment_group.buckets.forEach(element => {
                        let assignmentGroup = {};
                        assignmentGroup.name = element.key;
                        assignmentGroups.push(assignmentGroup);
                    });
                    alertFilterDispatch({ type: "add_assignment_group", item: assignmentGroups });
                }

                if (resp.aggregations.incident_status) {
                    let incidentStatusList = [];
                    resp.aggregations.incident_status.buckets.forEach(element => {
                        let incidentStatus = {};
                        incidentStatus.name = element.key;
                        incidentStatusList.push(incidentStatus);
                    });
                    alertFilterDispatch({ type: "add_incident_status", item: incidentStatusList });
                }
                if (workspace === workspaces.sap_ops) {
                    if (resp.aggregations.priorities.buckets) {
                        let prioritiesList = [];
                        resp.aggregations.priorities.buckets.forEach(element => {
                            let priority = {};
                            priority.name = element.key;
                            prioritiesList.push(priority);
                        });
                        alertFilterDispatch({ type: "add_priorities", item: prioritiesList });
                    }
                }

            }).catch((error) => {
                console.error('Error:', error);
            });

        // Sap Filters
        if (workspace === workspaces.sap_ops) {
            callGetApi(Constants.GETSAPALERTSFILTERDATAURL, { 'Content-Type': 'application/json' })
                .then(resp => {
                    if (resp.aggregations.franchises) {
                        let franchiseList = [];
                        resp.aggregations.franchises.buckets.forEach(element => {
                            let franchise = {};
                            franchise.name = element.key;
                            franchiseList.push(franchise);
                        });
                        alertFilterDispatch({ type: "add_franchise", item: franchiseList });
                    }

                }).catch((error) => {
                    console.error('Error:', error);
                });
        }


    }, [showExecutionDashboard, showSLACompliance, showIncidentManagement, showQueueEfficiency, workspace, props.accessibleDashboard, showCapacityManagement]);

    useEffect(() => {
        if (selectedDashboard === "TrustIndex" || selectedDashboard === "Execution" || selectedDashboard === "Capacity") {
            setBackgroundAOCCSupervisor(true);
            setBackgroundProcessOwner(true);
            setBackgroundAutomationCOE(false);
        } else if (selectedDashboard === "Remediation" || selectedDashboard === "SLA" || selectedDashboard === "ProductivityMetrics" || selectedDashboard === "Buisness" || selectedDashboard === "IncidentManagement" || selectedDashboard === "AlertManagement") {
            workspace === workspaces.automation_ops && selectedDashboard === "IncidentManagement" ? setBackgroundProcessOwner(false) : setBackgroundProcessOwner(true)
            workspace === workspaces.automation_ops && selectedDashboard === "IncidentManagement" ? setBackgroundAOCCSupervisor(true) : setBackgroundAOCCSupervisor(false)
            selectedDashboard !== "IncidentManagement" && setBackgroundProcessOwner(true);
            selectedDashboard !== "IncidentManagement" && setBackgroundAOCCSupervisor(false);
            setBackgroundAutomationCOE(true);
        } else {
            setBackgroundAutomationCOE(true);
            setBackgroundAOCCSupervisor(true);
            setBackgroundProcessOwner(false);
        }
    }, [workspace]);

    const setDefaultTimeFilter = () => {
        var selections = {};
        let endMoment = moment();
        let strEndMoment = endMoment.format();
        var formatedEndDate = endMoment.format('l');
        var formattedEndTime = endMoment.format('hh:mm');
        var endAMPM = endMoment.format('A');
        let startMoment = endMoment.subtract({ hours: 24 });
        let strStartMoment = startMoment.format();
        var formatedStartDate = startMoment.format('l');
        var formattedStartTime = startMoment.format('hh:mm');
        var startAMPM = startMoment.format('A');
        selections.startDateTime = strStartMoment
        selections.startDate = formatedStartDate;
        selections.startTime = formattedStartTime;
        selections.startAMPM = startAMPM;
        selections.endDateTime = strEndMoment;
        selections.endDate = formatedEndDate;
        selections.endTime = formattedEndTime;
        selections.endAMPM = endAMPM;
        selections.timeInterval = 0;
        selections.timeRangeType = "relative";  // relative , absolute
        selections.timeRange = "1D"; // can be 15m, 30m, 1H, 1D, 7D, 1M, 3M, 6M, 1Y, WTD, MTD, YTD
        setTimeFilterSelections(selections);
    }

    const getUserPreferences = async (user) => {
        setUserPrefs(null);
        setPreferencesChanged(false);
        let body = { 'user': user };

        let response = await callPostApi(Constants.GETUSERPREFRENCESURL, {
            'Content-Type': 'application/json'
        }, body);
        let respJson = await response;
        let userPrefs = {};
        if (respJson && respJson && respJson._source) {
            if (respJson._source.timeFilters) {
                let timeFilter = respJson._source.timeFilters;

                if (respJson._source.timeFilters.timeRangeType === "relative") {
                    timeFilter = getNewTimeRange(respJson._source.timeFilters.timeRange);
                    timeFilter.timeInterval = (respJson._source.timeFilters.timeInterval);
                }
                setTimeFilterSelections(timeFilter);
            } else {
                setDefaultTimeFilter();
            }

            if (respJson._source.workspace) {
                setWorkspace(respJson._source.workspace);
            }

            if (respJson._source.dashboard && respJson._source.dashboard.dashboardFiltersAutomation) {
                userPrefs.dashboardFiltersAutomation = respJson._source.dashboard.dashboardFiltersAutomation;
                setdashboardFilterSelectionsAutomation(userPrefs.dashboardFiltersAutomation)
                if (workspace === workspaces.automation_ops) {
                    if (userPrefs.dashboardFiltersAutomation.franchise) {
                        setSelectedFranchiseCount(userPrefs.dashboardFiltersAutomation.franchise.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.client) {
                        setSelectedClientCount(userPrefs.dashboardFiltersAutomation.client.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.geo) {
                        setSelectedGeoCount(userPrefs.dashboardFiltersAutomation.geo.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.priority) {
                        setSelectedPriorityCount(userPrefs.dashboardFiltersAutomation.priority.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.competency) {
                        setSelectedCompetencyCount(userPrefs.dashboardFiltersAutomation.competency.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.technology) {
                        setSelectedTechnologyCount(userPrefs.dashboardFiltersAutomation.technology.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.deployment_model) {
                        setSelectedDeploymentModelCount(userPrefs.dashboardFiltersAutomation.deployment_model.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.assignee) {
                        setSelectedAssigneeCount(userPrefs.dashboardFiltersAutomation.assignee.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.job_id) {
                        setSelectedJobIDCount(userPrefs.dashboardFiltersAutomation.job_id.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.incident_status) {
                        setSelectedIncidentStatusCount(userPrefs.dashboardFiltersAutomation.incident_status.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.queue_name) {
                        setSelectedQueueNameCount(userPrefs.dashboardFiltersAutomation.queue_name.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.status) {
                        setSelectedStatusCount(userPrefs.dashboardFiltersAutomation.status.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.automata_state) {
                        setSelectedAutomataStateCount(userPrefs.dashboardFiltersAutomation.automata_state.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.assigned_group) {
                        setSelectedAssignedGroupCount(userPrefs.dashboardFiltersAutomation.assigned_group.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.assignee_email) {
                        setSelectedAssigneeEmailCount(userPrefs.dashboardFiltersAutomation.assignee_email.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.assignment_group) {
                        setSelectedtAssignmentGroupCount(userPrefs.dashboardFiltersAutomation.assignment_group.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.automata_name) {
                        setSelectedAutomataNameCount(userPrefs.dashboardFiltersAutomation.automata_name.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.buisness_component) {
                        setSelectedBusinessComponentCount(userPrefs.dashboardFiltersAutomation.buisness_component.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.automata_activity_name) {
                        setSelectedAutomataActivityNameCount(userPrefs.dashboardFiltersAutomation.automata_activity_name.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.itemStatus_A1) {
                        setSelectedItemStatusA1Count(userPrefs.dashboardFiltersAutomation.itemStatus_A1.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.resource) {
                        setSelectedResourceCount(userPrefs.dashboardFiltersAutomation.resource.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.bot_id) {
                        setSelectedBotIdCount(userPrefs.dashboardFiltersAutomation.bot_id.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.process_name) {
                        setSelectedProcessNameCount(userPrefs.dashboardFiltersAutomation.process_name.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.remediation_type) {
                        setSelectedRemediationTypeCount(userPrefs.dashboardFiltersAutomation.remediation_type.length);
                    }

                }

            }

            if (respJson._source.dashboard && respJson._source.dashboard.dashboardFiltersSAP) {
                userPrefs.dashboardFiltersSAP = respJson._source.dashboard.dashboardFiltersSAP;
                setdashboardFilterSelectionsSAP(userPrefs.dashboardFiltersSAP)
                if (workspace === workspaces.sap_ops) {
                    if (userPrefs.dashboardFiltersSAP.franchise) {
                        setSelectedFranchiseCount(userPrefs.dashboardFiltersSAP.franchise.length);
                    }
                    if (userPrefs.dashboardFiltersSAP.client) {
                        setSelectedClientCount(userPrefs.dashboardFiltersSAP.client.length);
                    }
                    if (userPrefs.dashboardFiltersSAP.priority) {
                        setSelectedPriorityCount(userPrefs.dashboardFiltersSAP.priority.length);
                    }
                    if (userPrefs.dashboardFiltersSAP.assignment_group) {
                        setSelectedtAssignmentGroupCount(userPrefs.dashboardFiltersSAP.assignment_group.length);
                    }
                    if (userPrefs.dashboardFiltersSAP.assigned_group) {
                        setSelectedAssignedGroupCount(userPrefs.dashboardFiltersSAP.assigned_group.length);
                    }
                    if (userPrefs.dashboardFiltersSAP.incident_status) {
                        setSelectedIncidentStatusCount(userPrefs.dashboardFiltersSAP.incident_status.length);
                    }
                }

            }


        } else {
            setDefaultTimeFilter();
        }
        await setUserPrefs(userPrefs);
        setPreferencesChanged(true);
        // setDisplay(true);
    }

    const updateState = (state, stateValue, type) => {
        switch (state) {
            case 'dashboardFilterSelectionsAutomation':
                setdashboardFilterSelectionsAutomation(stateValue);
                updateUserPreferences(user.username, null, stateValue, null);
                break;
            case 'dashboardFilterSelectionsSAP':
                setdashboardFilterSelectionsSAP(stateValue);
                updateUserPreferences(user.username, null, null, stateValue);
                break;
            case 'timeFilterSelections':
                setTimeFilterSelections(stateValue);
                updateUserPreferences(user.username, stateValue, null, null);
                break;
            case 'disabledSelects':
                setDisabledSelects(stateValue);
                break;
            case 'alertFilterData_clients':
                alertFilterDispatch({ type: "add_clients", item: stateValue });
                break;
            default:
        }
    };

    const updateUserPreferences = async (user, timeFilters, dashboardFiltersAutomation, dashboardFiltersSAP) => {
        let body = { "user": user }; //, "timeFilters": timeFilters, "alertFilters": alertFilters, "pAlertFilters": pAlertFilters }
        let bodyJSON = {};
        bodyJSON.user = body.user;
        if (timeFilters) {
            bodyJSON.timeFilters = timeFilters;
        }

        let dashFiltersAutomation = {};
        let dashFiltersSAP = {};


        if (dashboardFiltersAutomation && workspace === workspaces.automation_ops) {

            dashFiltersAutomation =
            {
                "dashboardFiltersAutomation": dashboardFiltersAutomation

            };
            bodyJSON.dashboard = dashFiltersAutomation;
        }


        if (dashboardFiltersSAP && workspace === workspaces.sap_ops) {

            dashFiltersSAP =
            {
                "dashboardFiltersSAP": dashboardFiltersSAP
            };

            bodyJSON.dashboard = dashFiltersSAP;
        }


        //console.log("BODY", bodyJSON);

        callPostApi(Constants.UPDATEUSERPREFRENCESURL, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                getUserPreferences(body.user);
            }).catch((error) => {
                console.error('Error:', error);
            });
    };

    function alertFilterDataReducer(state, action) {
        switch (action.type) {
            case "add_franchise":
                return { ...state, franchises: action.item };
            case "add_clients":
                return { ...state, clients: action.item };
            case "add_technologies":
                return { ...state, technologies: action.item };
            case "add_deployment_models":
                return { ...state, deployment_models: action.item };
            case "add_geos":
                return { ...state, geos: action.item };
            case "add_competencies":
                return { ...state, competencies: action.item };
            case "add_priorities":
                return { ...state, priorities: action.item };
            case "add_assignee":
                return { ...state, assignees: action.item };
            case "add_assignee_email":
                return { ...state, assignees_email: action.item };
            case "add_assignment_group":
                return { ...state, assignment_group: action.item };
            case "add_incident_status":
                return { ...state, incident_status: action.item };
            case "add_automata_state":
                return { ...state, automata_state: action.item };
            case "add_busn_component":
                return { ...state, buisness_component: action.item };
            case "add_queue_nameGroups":
                return { ...state, queue_name: action.item };
            case "add_job_id":
                return { ...state, job_id: action.item };
            case "add_itemStatus_A1":
                return { ...state, itemStatus_A1: action.item };
            case "add_status":
                return { ...state, status: action.item };
            case "add_automata_name":
                return { ...state, automata_name: action.item };
            case "add_automata_activity_name":
                return { ...state, automata_activity_name: action.item };
            case "add_resource":
                return { ...state, resource: action.item };
            case "add_bot_id":
                return { ...state, bot_id: action.item };
            case "add_process_name":
                return { ...state, process_name: action.item };
            case "add_remediation_type":
                return { ...state, remediation_type: action.item };
            default:
                return { ...state };

        }
    }

    const handleFilters = () => {
        setShowFilters(!showFilters);
    };

    const handleClose = () => {
        setShowFilters(!showFilters);
    }

    const handleExecution = () => {
        setExecutionDashboard(true);
    }

    const changeDashboard = (type) => {
        setSelectedDashboard(type);
        setShowAOCCSupervisorDashboardList(false);
        setShowProcessOwnerDashboardList(false);
        setShowAutomationCOEDashboardList(false);
    };

    const handleProcessOwnerDashboardList = () => {
        setBackgroundProcessOwner(false);
        if (selectedDashboard === "IncidentManagement" || selectedDashboard === "QueueEfficiency" || selectedDashboard === "Bot" ||
            selectedDashboard === "SchedulingEfficiency" || selectedDashboard === "QueueManagement" || selectedDashboard === "Bpmn" || selectedDashboard === "ServiceDeskTriagePerformance") {
            setBackgroundAOCCSupervisor(false);
        }
        // setBackgroundProcessOwner(!isBackgroundProcessOwnerSelected);
        setBackgroundAOCCSupervisor(true);
        setBackgroundAutomationCOE(true);
        setShowProcessOwnerDashboardList(!showProcessOwnerDashboardList);
        setShowAOCCSupervisorDashboardList(false);
        setShowAutomationCOEDashboardList(false);
    };

    const handleAOCCSupervisorDashboardList = () => {
        setBackgroundAOCCSupervisor(false);
        if (selectedDashboard === "Remediation" || selectedDashboard === "SLA" || selectedDashboard === "ProductivityMetrics" ||
            selectedDashboard === "Buisness" || selectedDashboard === "IncidentManagement" || selectedDashboard === "AlertManagement") {
            setBackgroundAOCCSupervisor(false);
        }
        // setBackgroundAOCCSupervisor(!isBackgroundAOCCSupervisorSelected);
        setBackgroundProcessOwner(true);
        setBackgroundAutomationCOE(true);
        setShowAOCCSupervisorDashboardList(!showAOCCSupervisorDashboardList)
        setShowProcessOwnerDashboardList(false);
        setShowAutomationCOEDashboardList(false);
    };

    const handleAutomationCOEDashboardList = () => {
        setBackgroundAutomationCOE(false);
        if (selectedDashboard === "TrustIndex" || selectedDashboard === "Execution" || selectedDashboard === "Capacity") {
            setBackgroundAOCCSupervisor(false);
        }
        // setBackgroundAutomationCOE(!isBackgroundAutomationCOESelected);
        setBackgroundAOCCSupervisor(true);
        setBackgroundProcessOwner(true);
        setShowAutomationCOEDashboardList(!showAutomationCOEDashboardList);
        setShowAOCCSupervisorDashboardList(false);
        setShowProcessOwnerDashboardList(false);
    };

    const getStartTime = () => {
        if (timeFilterSelections.startDateTime) {
            let startM = moment(timeFilterSelections.startDateTime);
            let startMStr = startM.locale("en").format("llll");
            return startMStr;
        }
        else {
            return "";
        }
    };

    const getEndTime = () => {
        if (timeFilterSelections.endDateTime) {
            let endM = moment(timeFilterSelections.endDateTime);
            let endMStr = endM.locale("en").format("llll");
            return endMStr;
        }
        else {
            return "";
        }
    };


    const handleFilterLabel = (type) => {
        switch (type) {
            case "Franchise":
                if (workspace === workspaces.automation_ops) {
                    updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "franchise": [], "client": [] });
                }
                if (workspace === workspaces.sap_ops) {
                    updateState('dashboardFilterSelectionsSAP', { ...dashboardFilterSelectionsSAP, "franchise": [], "client": [] });
                }
                setShowFilters(false);
                break;
            case "Client":
                if (workspace === workspaces.automation_ops) {
                    updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "client": [] });
                }
                if (workspace === workspaces.sap_ops) {
                    updateState('dashboardFilterSelectionsSAP', { ...dashboardFilterSelectionsSAP, "client": [] });
                }
                setShowFilters(false);
                break;
            case "Technology":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "technology": [] });
                setShowFilters(false);
                break;
            case "DeploymentModel":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "deployment_model": [] });
                setShowFilters(false);
                break;
            case "Geo":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, 'geo': [] });
                setShowFilters(false);
                break;
            case "Competency":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "competency": [] });
                setShowFilters(false);
                break;
            case "Priority":
                if (workspace === workspaces.automation_ops) {
                    updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "priority": [] });
                }
                if (workspace === workspaces.sap_ops) {
                    updateState('dashboardFilterSelectionsSAP', { ...dashboardFilterSelectionsSAP, "priority": [] });
                }
                setShowFilters(false);
                break;
            case "Status":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "status": [] });
                setShowFilters(false);
                break;
            case "Assignee":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "assignee": [] });
                setShowFilters(false);
                break;
            case "AssigneeEmail":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "assignee_email": [] });
                setShowFilters(false);
                break;
            case "AssignedGroup":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "assigned_group": [] });
                setShowFilters(false);
                break;
            case "AssignmentGroup":

                if (workspace === workspaces.automation_ops) {
                    updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "assignment_group": [] });
                }
                if (workspace === workspaces.sap_ops) {
                    updateState('dashboardFilterSelectionsSAP', { ...dashboardFilterSelectionsSAP, "assignment_group": [] });
                }
                setShowFilters(false);
                break;
            case "IncidentStatus":
                if (workspace === workspaces.automation_ops) {
                    updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "incident_status": [] });
                }
                if (workspace === workspaces.sap_ops) {
                    updateState('dashboardFilterSelectionsSAP', { ...dashboardFilterSelectionsSAP, "incident_status": [] });
                }
                setShowFilters(false);
                break;
            case "BusinessComponent":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "buisness_component": [] });
                setShowFilters(false);
                break;
            case "AutomataState":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "automata_state": [] });
                setShowFilters(false);
                break;
            case "AutomataName":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "automata_name": [] });
                setShowFilters(false);
                break;
            case "ItemStatusA1":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "itemStatus_A1": [] });
                setShowFilters(false);
                break;
            case "JobId":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "job_id": [] });
                setShowFilters(false);
                break;
            case "AutomataActivityName":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "automata_activity_name": [] });
                setShowFilters(false);
                break;
            case "Resource":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "resource": [] });
                setShowFilters(false);
                break;
            case "BotId":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "bot_id": [] });
                setShowFilters(false);
                break;
            case "QueueName":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "queue_name": [] });
                setShowFilters(false);
                break;
            case "ProcessName":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "process_name": [] });
                setShowFilters(false);
                break;
            case "RemediationType":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "remediation_type": [] });
                setShowFilters(false);
                break;
            default:
        }
    };


    function handleItemClick(item) {
        setSelectedKpi(item);
    }


    return (
        <div className="dashboard-header-panel">
            <div className="header">
                <div className="breadcrumb">
                    <Breadcrumb aria-label="Page navigation">
                        <BreadcrumbItem href='/homepage'>
                            {DashboardConstants.home}
                        </BreadcrumbItem>
                    </Breadcrumb>
                    <div className="title">
                        {DashboardConstants.Analytics}
                    </div>
                </div>
                <div className="time-filter-container">
                    <div className="time carbon-display-Regular-16">{getStartTime()}</div>
                    <div>{' ' + '-' + ' '}</div>
                    <div className="time carbon-display-Regular-16">{getEndTime()}</div>
                    <div className="time-filter-button" >
                        <TimeFilter updateState={updateState} timeFilterSelections={timeFilterSelections}></TimeFilter>
                    </div>
                </div>
            </div>
            <div className="content-wrapper no-gutters">
                <div className={workspace === workspaces.sap_ops ? "role-container col-lg-2 no-gutters" : "role-container col-lg-2 no-gutters"}>
                    <div className="role">
                        <div className={workspace === workspaces.automation_ops ? "title carbon-display-Semibold-14" : "sapOps-title carbon-display-Semibold-14"}>
                            {DashboardConstants.IAmA}
                        </div>
                        <div className={workspace === workspaces.sap_ops ? "sap name-container" : "name-container"}>
                            {config.URL.includes(config.unilever) && roles && roles.includes("Automation CoE") === true ?
                                <div className='disable name' id="Supervisor" onClick={handleAOCCSupervisorDashboardList}>
                                    <div className="name-title carbon-display-Regular-14">
                                        {DashboardConstants.Supervisor}
                                    </div>
                                    <div className="image-container">
                                        <img src={AOCCSupervisor} alt="" />
                                    </div>
                                </div> : <div className={isBackgroundAOCCSupervisorSelected ? 'name' : 'name-blue'} id="Supervisor" onClick={handleAOCCSupervisorDashboardList}>
                                    <div className="name-title carbon-display-Regular-14">
                                        {DashboardConstants.Supervisor}
                                    </div>
                                    <div className="image-container">
                                        <img src={AOCCSupervisor} alt="" />
                                    </div>
                                </div>}
                            {config.URL.includes(config.unilever) && roles && roles.includes("Automation CoE") === true ?

                                <div className='disable name' id="ProcessOwner" onClick={handleProcessOwnerDashboardList}>
                                    <div className="name-title carbon-display-Regular-14" >
                                        {DashboardConstants.Process}<br />{DashboardConstants.Owner}
                                    </div>
                                    <div className="image-container">
                                        <img src={ProcessOwner} alt="" />
                                    </div>
                                </div> : <div className={isBackgroundProcessOwnerSelected ? 'name' : 'name-blue'} id="ProcessOwner" onClick={handleProcessOwnerDashboardList}>
                                    <div className="name-title carbon-display-Regular-14" >
                                        {DashboardConstants.Process}<br />{DashboardConstants.Owner}
                                    </div>
                                    <div className="image-container">
                                        <img src={ProcessOwner} alt="" />
                                    </div>
                                </div>}
                            {workspace === workspaces.automation_ops ?
                                <div className={isBackgroundAutomationCOESelected ? 'name' : 'name-blue'} id="AutomationCoE" onClick={handleAutomationCOEDashboardList}>
                                    <div className="name-title carbon-display-Regular-14">
                                        {DashboardConstants.Automation}<br />{DashboardConstants.CoE}
                                    </div>
                                    <div className="image-container">
                                        <img src={AutomationCoE} alt="" />
                                    </div>
                                </div> : null}
                        </div>
                    </div>

                    {showProcessOwnerDashboardList ?
                        <TileGroup defaultSelected={selectedDashboard}>
                            {/* <RadioTile tabIndex={0} value="Buisness" onClick={() => changeDashboard("Buisness")}>
            Buisness entities throughput</RadioTile>
        <RadioTile tabIndex={0} value="FTE" onClick={() => changeDashboard("FTE")}>
            FTE Productivity
        </RadioTile>  */}
                            {workspace === workspaces.automation_ops && config.URL.includes(config.unilever) && accesibleDashboards.includes('BusinessViewValueRealization') ?
                                <RadioTile tabIndex={0} value="BusinessViewValueRealization" onClick={() => changeDashboard("BusinessViewValueRealization")}>
                                    {DashboardConstants.BusinessViewValueRealization}
                                </RadioTile> : null}
                            {workspace === workspaces.automation_ops && config.URL.includes(config.unilever) && accesibleDashboards.includes('Capacity') ?
                                <RadioTile tabIndex={0} value="Capacity" onClick={() => changeDashboard("Capacity")}>
                                    {DashboardConstants.CapacityManagement}</RadioTile>
                                : null}

                            {workspace === workspaces.automation_ops && accesibleDashboards.includes('IncidentManagement') ?
                                <RadioTile tabIndex={0} value="IncidentManagement" onClick={() => changeDashboard("IncidentManagement")}>
                                    {DashboardConstants.IncidentManagementEfficiency}</RadioTile>
                                : null}

                            {workspace === workspaces.automation_ops && config.URL.includes(config.unilever) === false && accesibleDashboards.includes('QueueEfficiency') ?
                                <RadioTile tabIndex={0} value="QueueEfficiency" onClick={() => changeDashboard("QueueEfficiency")}>
                                    {DashboardConstants.QueueEfficiency}
                                </RadioTile>
                                : null}
                            {workspace === workspaces.automation_ops && config.URL.includes(config.unilever) === false && accesibleDashboards.includes('Bot') ?
                                <RadioTile tabIndex={0} value="Bot" onClick={() => changeDashboard("Bot")}>
                                    {DashboardConstants.BotPerformance}
                                </RadioTile>
                                : null}
                            {workspace === workspaces.automation_ops && config.URL.includes(config.unilever) === false && accesibleDashboards.includes('SchedulingEfficiency') ?
                                <RadioTile tabIndex={0} value="SchedulingEfficiency" onClick={() => changeDashboard("SchedulingEfficiency")}>
                                    {DashboardConstants.SchedulingEfficiency}
                                </RadioTile>
                                : null}
                            {workspace === workspaces.automation_ops && config.URL.includes(config.unilever) === false && accesibleDashboards.includes('QueueManagement') ?
                                <RadioTile tabIndex={0} value="QueueManagement" onClick={() => changeDashboard("QueueManagement")}>
                                    {DashboardConstants.QueueManagement}
                                </RadioTile> : null}
                            {/*workspace === workspaces.sap_ops && accesibleDashboards.includes('Bpmn') ?
                                <RadioTile tabIndex={0} value="Bpmn" onClick={() => changeDashboard("Bpmn")}>
                                    {DashboardConstants.Bpmn}
                                </RadioTile>
                                : null} */}

                            {workspace === workspaces.sap_ops && accesibleDashboards.includes('ServiceDeskTriagePerformance') ?
                                <RadioTile tabIndex={0} value="ServiceDeskTriagePerformance" onClick={() => changeDashboard("ServiceDeskTriagePerformance")}>
                                    {DashboardConstants.Juniper}</RadioTile>
                                : null}
                            {workspace === workspaces.automation_ops && accesibleDashboards.includes('AutomationBusinessCatalogue') ?
                                <RadioTile tabIndex={0} value="AutomationBusinessCatalogue" onClick={() => changeDashboard("AutomationBusinessCatalogue")}>
                                    {DashboardConstants.AutomationBusinessCatalogue}
                                </RadioTile> : null}

                        </TileGroup>
                        : null}

                    {showAOCCSupervisorDashboardList ?
                        <TileGroup defaultSelected={selectedDashboard}>
                            {workspace === workspaces.sap_ops && accesibleDashboards.includes('IncidentManagement') ?
                                <RadioTile tabIndex={0} value="IncidentManagement" onClick={() => changeDashboard("IncidentManagement")}>
                                    {DashboardConstants.IncidentManagementEfficiency}</RadioTile>
                                : null}

                            {workspace === workspaces.automation_ops && accesibleDashboards.includes('Remediation') ?
                                <RadioTile tabIndex={0} value="Remediation" onClick={() => changeDashboard("Remediation")}>
                                    {DashboardConstants.Remediation}
                                </RadioTile>
                                : null}
                            {workspace === workspaces.automation_ops && config.URL.includes(config.unilever) && accesibleDashboards.includes('Bot') ?
                                <RadioTile tabIndex={0} value="Bot" onClick={() => changeDashboard("Bot")}>
                                    {DashboardConstants.BotPerformance}
                                </RadioTile>
                                : null}
                            {accesibleDashboards.includes('SLA') ?
                                <RadioTile tabIndex={0} value="SLA" onClick={() => changeDashboard("SLA")}>
                                    {DashboardConstants.SLACompliance}
                                </RadioTile>
                                : null
                            }
                            {workspace === workspaces.automation_ops && config.URL.includes(config.unilever) && accesibleDashboards.includes('Execution') ?
                                <RadioTile tabIndex={0} value="Execution" onClick={() => changeDashboard("Execution")}>
                                    {DashboardConstants.ExecutionPerformance}
                                </RadioTile>
                                : null}

                            {workspace === workspaces.automation_ops && config.URL.includes(config.unilever) === false && accesibleDashboards.includes('ProductivityMetrics') ?
                                <RadioTile tabIndex={0} value="ProductivityMetrics" onClick={() => changeDashboard("ProductivityMetrics")}>
                                    {DashboardConstants.ProductivityMetrics}
                                </RadioTile> : null}
                            {workspace === workspaces.sap_ops && accesibleDashboards.includes('AlertManagement') ?
                                <RadioTile tabIndex={0} value="AlertManagement" onClick={() => changeDashboard("AlertManagement")}>
                                    {DashboardConstants.AlertManagement}
                                </RadioTile>
                                : null}
                            {workspace === workspaces.automation_ops && config.URL.includes(config.unilever) === false && accesibleDashboards.includes('BusinessViewValueRealization') ?
                                <RadioTile tabIndex={0} value="BusinessViewValueRealization" onClick={() => changeDashboard("BusinessViewValueRealization")}>
                                    {DashboardConstants.BusinessViewValueRealization}
                                </RadioTile> : null}
                        </TileGroup>
                        : null}

                    {showAutomationCOEDashboardList ?
                        <TileGroup defaultSelected={selectedDashboard}>

                            {workspace === workspaces.automation_ops && config.URL.includes(config.unilever) && accesibleDashboards.includes('SchedulingEfficiency') ?
                                <RadioTile tabIndex={0} value="SchedulingEfficiency" onClick={() => changeDashboard("SchedulingEfficiency")}>
                                    {DashboardConstants.SchedulingEfficiency}
                                </RadioTile>
                                : null}
                            {workspace === workspaces.automation_ops && config.URL.includes(config.unilever) && accesibleDashboards.includes('QueueEfficiency') ?
                                <RadioTile tabIndex={0} value="QueueEfficiency" onClick={() => changeDashboard("QueueEfficiency")}>
                                    {DashboardConstants.QueueEfficiency}
                                </RadioTile>
                                : null}
                            {workspace === workspaces.automation_ops && config.URL.includes(config.unilever) && accesibleDashboards.includes('QueueManagement') ?
                                <RadioTile tabIndex={0} value="QueueManagement" onClick={() => changeDashboard("QueueManagement")}>
                                    {DashboardConstants.QueueManagement}
                                </RadioTile> : null}
                            {workspace === workspaces.automation_ops && accesibleDashboards.includes('TrustIndex') ?
                                <RadioTile tabIndex={0} value="TrustIndex" onClick={() => changeDashboard("TrustIndex")}>
                                    {DashboardConstants.AutomationTrustIndex}
                                </RadioTile> : null}
                            {/* changeDashboard("Execution") */}
                            {config.URL.includes(config.unilever) === false && accesibleDashboards.includes('Execution') ?
                                <RadioTile tabIndex={0} value="Execution" onClick={() => changeDashboard("Execution")}>
                                    {DashboardConstants.ExecutionPerformance}
                                </RadioTile>
                                : null}
                            {config.URL.includes(config.unilever) === false && accesibleDashboards.includes('Capacity') ?
                                <RadioTile tabIndex={0} value="Capacity" onClick={() => changeDashboard("Capacity")}>
                                    {DashboardConstants.CapacityManagement}</RadioTile>
                                : null}
                            {workspace === workspaces.automation_ops && config.URL.includes(config.unilever) && accesibleDashboards.includes('ProductivityMetrics') ?
                                <RadioTile tabIndex={0} value="ProductivityMetrics" onClick={() => changeDashboard("ProductivityMetrics")}>
                                    {DashboardConstants.ProductivityMetrics}
                                </RadioTile> : null}

                            {config.URL.includes(config.unilever) === false && accesibleDashboards.includes('UsageStats') ?
                                <RadioTile tabIndex={0} value="UsageStats" onClick={() => changeDashboard("UsageStats")}>Usage Stats</RadioTile>
                                : null}
                        </TileGroup>
                        : null}

                    {selectedDashboard === "AutomationBusinessCatalogue" ?
                        <div>
                            <div>
                                {selectedFranchiseCount > 0 || selectedClientCount > 0 || selectedGeoCount > 0 || selectedTechnologyCount > 0 || selectedDeploymentModelCount > 0 || selectedCompetencyCount > 0 || selectedPriorityCount > 0 ||
                                    selectedAssigneeCount > 0 || selectedJobIDCount > 0 || selectedStatusCount > 0 || selectedIncidentStatusCount > 0 || selectedQueueNameCount > 0 || selectedAutomataStateCount > 0 || selectedAutomataStateCount > 0 ||
                                    selectedAssignedGroupCount > 0 || selectedAutomataActivityNameCount > 0 || selectedAutomataNameCount > 0 || selectedBusinessComponentCount > 0 || selectedItemStatusA1Count > 0 || selectedResourceCount > 0 || selectedBotIdCount > 0 || selectedAssignmentGroupCount > 0 || selectedProcessNameCount > 0 ?

                                    <div className="stats">
                                        <div className="stats-label">{DashboardConstants.ShowingStatsFor}</div>
                                        {selectedFranchiseCount > 0 ?
                                            <div className="stats-color"><Tag type="blue">{selectedFranchiseCount} {DashboardConstants.franchise}<Close32 onClick={() => handleFilterLabel('Franchise')} /></Tag></div> : null}
                                        {selectedClientCount > 0 ?
                                            <div className="stats-color"><Tag type="blue">{selectedClientCount} {DashboardConstants.Client}<Close32 onClick={() => handleFilterLabel('Client')} /></Tag> </div> : null}
                                        {selectedAssigneeCount > 0 ?
                                            <div className="stats-color"><Tag type="blue">{selectedAssigneeCount} {DashboardConstants.Assignee}<Close32 onClick={() => handleFilterLabel('Assignee')} /></Tag></div> : null}
                                        {selectedTechnologyCount > 0 ?
                                            <div className="stats-color"> <Tag type="blue">{selectedTechnologyCount} {DashboardConstants.Technology}<Close32 onClick={() => handleFilterLabel('Technology')} /></Tag></div> : null}
                                        {selectedDeploymentModelCount > 0 ?
                                            <div className="stats-color"><Tag type="blue">{selectedDeploymentModelCount} {DashboardConstants.DeploymentModel}<Close32 onClick={() => handleFilterLabel('DeploymentModel')} /></Tag></div> : null}
                                        {selectedGeoCount > 0 ?
                                            <div className="stats-color"><Tag type="blue">{selectedGeoCount} {DashboardConstants.Geo}<Close32 onClick={() => handleFilterLabel('Geo')} /></Tag></div> : null}
                                        {selectedPriorityCount > 0 ?
                                            <div className="stats-color"><Tag type="blue">{selectedPriorityCount} {DashboardConstants.FilterPriority}<Close32 onClick={() => handleFilterLabel('Priority')} /></Tag></div> : null}
                                        {selectedJobIDCount > 0 ?
                                            <div className="stats-color"><Tag type="blue">{selectedJobIDCount} {DashboardConstants.JobId}<Close32 onClick={() => handleFilterLabel('JobId')} /></Tag></div> : null}
                                        {selectedStatusCount > 0 ?
                                            <div className="stats-color"><Tag type="blue">{selectedStatusCount} {DashboardConstants.Status}<Close32 onClick={() => handleFilterLabel('Status')} /></Tag></div> : null}
                                        {selectedCompetencyCount > 0 ?
                                            <div className="stats-color"><Tag type="blue">{selectedCompetencyCount} {config.URL.includes(config.unilever) ? DashboardConstants.LeadPlatform : DashboardConstants.Competency}<Close32 onClick={() => handleFilterLabel('Competency')} /></Tag></div> : null}
                                        {selectedIncidentStatusCount > 0 ?
                                            <div className="stats-color"><Tag type="blue">{selectedIncidentStatusCount} {DashboardConstants.FilterIncidentStatus}<Close32 onClick={() => handleFilterLabel('IncidentStatus')} /></Tag></div> : null}
                                        {selectedQueueNameCount > 0 ?
                                            <div className="stats-color"><Tag type="blue">{selectedQueueNameCount} {DashboardConstants.QueueName}<Close32 onClick={() => handleFilterLabel('QueueName')} /></Tag></div> : null}
                                        {selectedAutomataStateCount > 0 ?
                                            <div className="stats-color"><Tag type="blue">{selectedAutomataStateCount} {DashboardConstants.AutomataState}<Close32 onClick={() => handleFilterLabel('AutomataState')} /></Tag></div> : null}
                                        {selectedAssignedGroupCount > 0 ?
                                            <div className="stats-color"><Tag type="blue">{selectedAssignedGroupCount} {DashboardConstants.AssignedGroup}<Close32 onClick={() => handleFilterLabel('AssignedGroup')} /></Tag></div> : null}
                                        {selectedAssigneeEmailCount > 0 ?
                                            <div className="stats-color"><Tag type="blue">{selectedAssigneeEmailCount} {DashboardConstants.AssigneeEmail}<Close32 onClick={() => handleFilterLabel('AssignedEmail')} /></Tag></div> : null}
                                        {selectedAssignmentGroupCount > 0 ?
                                            <div className="stats-color"><Tag type="blue">{selectedAssignmentGroupCount} {DashboardConstants.AssignmentGp}<Close32 onClick={() => handleFilterLabel('AssignmentGroup')} /></Tag></div> : null}
                                        {selectedAutomataNameCount > 0 ?
                                            <div className="stats-color"><Tag type="blue">{selectedAutomataNameCount} {DashboardConstants.AutomataName}<Close32 onClick={() => handleFilterLabel('AutomataName')} /></Tag></div> : null}
                                        {selectedAutomataActivityNameCount > 0 ?
                                            <div className="stats-color"><Tag type="blue">{selectedAutomataActivityNameCount} {config.URL.includes(config.unilever) ? DashboardConstants.BotName : DashboardConstants.AutomataName} <Close32 onClick={() => handleFilterLabel('AutomataActivityName')} /></Tag></div> : null}
                                        {selectedBusinessComponentCount > 0 ?
                                            <div className="stats-color"><Tag type="blue">{selectedBusinessComponentCount} {config.URL.includes(config.unilever) ? DashboardConstants.SubArea : DashboardConstants.BusinessComponent}<Close32 onClick={() => handleFilterLabel('BusinessComponent')} /></Tag></div> : null}
                                        {selectedItemStatusA1Count > 0 ?
                                            <div className="stats-color"><Tag type="blue">{selectedItemStatusA1Count} {DashboardConstants.ItemStatusA1}<Close32 onClick={() => handleFilterLabel('ItemStatusA1')} /></Tag></div> : null}
                                        {selectedResourceCount > 0 ?
                                            <div className="stats-color"><Tag type="blue">{selectedResourceCount} {DashboardConstants.Resource}<Close32 onClick={() => handleFilterLabel('Resource')} /></Tag></div> : null}
                                        {selectedBotIdCount > 0 ?
                                            <div className="stats-color"><Tag type="blue">{selectedBotIdCount} {DashboardConstants.BotID}<Close32 onClick={() => handleFilterLabel('BotId')} /></Tag></div> : null}
                                        {selectedProcessNameCount > 0 ?
                                            <div className="stats-color"><Tag type="blue">{selectedProcessNameCount} {DashboardConstants.ProcessName}<Close32 onClick={() => handleFilterLabel('ProcessName')} /></Tag></div> : null}
                                    </div>
                                    : null}
                                <div className={workspace === workspaces.sap_ops ? "sapOps-filter-container" : "filter-container"}>
                                    <Button iconDescription='Filters' onClick={handleFilters} renderIcon={FilterEdit32}>{DashboardConstants.AutomationBusinessFilters}</Button>
                                </div>
                            </div>
                            {showFilters ? <Tabs>
                                <Tab label="Filters">
                                    <div><DashboardFilters alertType={"reactive"} filterData={alertFilterData} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP}
                                        disabledSelects={disabledSelects} handleClose={handleClose} updateState={updateState} dashboardType={selectedDashboard} workspace={workspace} />
                                    </div>
                                </Tab>
                                <Tab label="Lens" className='lens'>
                                    <div className='lens-section'>
                                        <TileGroup defaultSelected={selectedKpi}>
                                            <RadioTile tabIndex={0} value="Hours saved" onClick={(e) => handleItemClick(DashboardConstants.ROI)}>
                                                {DashboardConstants.ROI}
                                            </RadioTile>
                                            <RadioTile tabIndex={0} value="successrate" onClick={(e) => handleItemClick(DashboardConstants.successrate)}>
                                                {DashboardConstants.successrate}
                                            </RadioTile>
                                            <RadioTile tabIndex={0} value="Terminationrate" onClick={(e) => handleItemClick(DashboardConstants.Terminationrate)}>
                                                {DashboardConstants.Terminationrate}
                                            </RadioTile>
                                            <RadioTile tabIndex={0} value="CapacityUtilization" onClick={(e) => handleItemClick(DashboardConstants.CapacityUtilization)}>
                                                {DashboardConstants.CapacityUtilization}
                                            </RadioTile>
                                            {/* <RadioTile tabIndex={0} value="SelfHealRate" onClick={(e) => handleItemClick(DashboardConstants.SelfHealRate)}>
                                                {DashboardConstants.SelfHealRate}
                                            </RadioTile> */}
                                        </TileGroup>
                                    </div>
                                </Tab>
                            </Tabs> : null}
                        </div> :
                        workspace === workspaces.sap_ops || workspace === workspaces.automation_ops && selectedDashboard !== 'AutomationBusinessCatalogue' ?
                            <div>
                                <div>
                                    {selectedFranchiseCount > 0 || selectedClientCount > 0 || selectedGeoCount > 0 || selectedTechnologyCount > 0 || selectedDeploymentModelCount > 0 || selectedCompetencyCount > 0 || selectedPriorityCount > 0 ||
                                        selectedAssigneeCount > 0 || selectedJobIDCount > 0 || selectedStatusCount > 0 || selectedIncidentStatusCount > 0 || selectedQueueNameCount > 0 || selectedAutomataStateCount > 0 || selectedAutomataStateCount > 0 ||
                                        selectedAssignedGroupCount > 0 || selectedAutomataActivityNameCount > 0 || selectedAutomataNameCount > 0 || selectedBusinessComponentCount > 0 || selectedItemStatusA1Count > 0 || selectedResourceCount > 0 || selectedBotIdCount > 0 || selectedAssignmentGroupCount > 0 || selectedProcessNameCount > 0 || selectedRemediationTypeCount > 0 ?

                                        <div className="stats">
                                            <div className="stats-label">{DashboardConstants.ShowingStatsFor}</div>
                                            {selectedFranchiseCount > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedFranchiseCount} {DashboardConstants.franchise}<Close32 onClick={() => handleFilterLabel('Franchise')} /></Tag></div> : null}
                                            {selectedClientCount > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedClientCount} {DashboardConstants.Client}<Close32 onClick={() => handleFilterLabel('Client')} /></Tag> </div> : null}
                                            {selectedAssigneeCount > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedAssigneeCount} {DashboardConstants.Assignee}<Close32 onClick={() => handleFilterLabel('Assignee')} /></Tag></div> : null}
                                            {selectedTechnologyCount > 0 ?
                                                <div className="stats-color"> <Tag type="blue">{selectedTechnologyCount} {DashboardConstants.Technology}<Close32 onClick={() => handleFilterLabel('Technology')} /></Tag></div> : null}
                                            {selectedDeploymentModelCount > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedDeploymentModelCount} {DashboardConstants.DeploymentModel}<Close32 onClick={() => handleFilterLabel('DeploymentModel')} /></Tag></div> : null}
                                            {selectedGeoCount > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedGeoCount} {DashboardConstants.Geo}<Close32 onClick={() => handleFilterLabel('Geo')} /></Tag></div> : null}
                                            {selectedPriorityCount > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedPriorityCount} {DashboardConstants.FilterPriority}<Close32 onClick={() => handleFilterLabel('Priority')} /></Tag></div> : null}
                                            {selectedJobIDCount > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedJobIDCount} {DashboardConstants.JobId}<Close32 onClick={() => handleFilterLabel('JobId')} /></Tag></div> : null}
                                            {selectedStatusCount > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedStatusCount} {DashboardConstants.Status}<Close32 onClick={() => handleFilterLabel('Status')} /></Tag></div> : null}
                                            {selectedCompetencyCount > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedCompetencyCount} {config.URL.includes(config.unilever) ? DashboardConstants.LeadPlatform : DashboardConstants.Competency}<Close32 onClick={() => handleFilterLabel('Competency')} /></Tag></div> : null}
                                            {selectedIncidentStatusCount > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedIncidentStatusCount} {DashboardConstants.FilterIncidentStatus}<Close32 onClick={() => handleFilterLabel('IncidentStatus')} /></Tag></div> : null}
                                            {selectedQueueNameCount > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedQueueNameCount} {DashboardConstants.QueueName}<Close32 onClick={() => handleFilterLabel('QueueName')} /></Tag></div> : null}
                                            {selectedAutomataStateCount > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedAutomataStateCount} {DashboardConstants.AutomataState}<Close32 onClick={() => handleFilterLabel('AutomataState')} /></Tag></div> : null}
                                            {selectedAssignedGroupCount > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedAssignedGroupCount} {DashboardConstants.AssignedGroup}<Close32 onClick={() => handleFilterLabel('AssignedGroup')} /></Tag></div> : null}
                                            {selectedAssigneeEmailCount > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedAssigneeEmailCount} {DashboardConstants.AssigneeEmail}<Close32 onClick={() => handleFilterLabel('AssignedEmail')} /></Tag></div> : null}
                                            {selectedAssignmentGroupCount > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedAssignmentGroupCount} {DashboardConstants.AssignmentGp}<Close32 onClick={() => handleFilterLabel('AssignmentGroup')} /></Tag></div> : null}
                                            {selectedAutomataNameCount > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedAutomataNameCount} {DashboardConstants.AutomataName}<Close32 onClick={() => handleFilterLabel('AutomataName')} /></Tag></div> : null}
                                            {selectedAutomataActivityNameCount > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedAutomataActivityNameCount} {config.URL.includes(config.unilever) ? DashboardConstants.BotName : DashboardConstants.AutomataName} <Close32 onClick={() => handleFilterLabel('AutomataActivityName')} /></Tag></div> : null}
                                            {selectedBusinessComponentCount > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedBusinessComponentCount} {config.URL.includes(config.unilever) ? DashboardConstants.SubArea : DashboardConstants.BusinessComponent}<Close32 onClick={() => handleFilterLabel('BusinessComponent')} /></Tag></div> : null}
                                            {selectedItemStatusA1Count > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedItemStatusA1Count} {DashboardConstants.ItemStatusA1}<Close32 onClick={() => handleFilterLabel('ItemStatusA1')} /></Tag></div> : null}
                                            {selectedResourceCount > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedResourceCount} {DashboardConstants.Resource}<Close32 onClick={() => handleFilterLabel('Resource')} /></Tag></div> : null}
                                            {selectedBotIdCount > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedBotIdCount} {DashboardConstants.BotID}<Close32 onClick={() => handleFilterLabel('BotId')} /></Tag></div> : null}
                                            {selectedProcessNameCount > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedProcessNameCount} {DashboardConstants.ProcessName}<Close32 onClick={() => handleFilterLabel('ProcessName')} /></Tag></div> : null}
                                            {selectedRemediationTypeCount > 0 ?
                                                <div className="stats-color"><Tag type="blue">{selectedRemediationTypeCount} {DashboardConstants.RemediationType}<Close32 onClick={() => handleFilterLabel('RemediationType')} /></Tag></div> : null}
                                        </div>
                                        : null}
                                    <div className={workspace === workspaces.sap_ops ? "sapOps-filter-container" : "filter-container"}>
                                        <Button iconDescription='Filters' onClick={handleFilters} renderIcon={FilterEdit32}>{DashboardConstants.Filters}</Button>
                                    </div>
                                </div>
                                {showFilters ?
                                    <div><DashboardFilters alertType={"reactive"} filterData={alertFilterData} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP}
                                        disabledSelects={disabledSelects} handleClose={handleClose} updateState={updateState} dashboardType={selectedDashboard} workspace={workspace} /> </div> : null}
                            </div> : null}
                </div>
                {preferencesChanged ?
                    <div className={"col-lg-10 dashboards-wrapper"}>
                        {selectedDashboard === 'Execution' ?
                            <div><ExecutionPerformance preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'IncidentManagement' ?
                            <div><IncidentManagement preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'QueueEfficiency' ?
                            <div><QueueEfficiency preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'SLA' ?
                            <div><SLACompliance preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'AlertManagement' ?
                            <div><AlertManagement preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'QueueManagement' ?
                            <div><QueueManagement preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'Capacity' ?
                            <div> {config.URL.includes(config.unilever) ? <div><UllCapacityManagement preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} workspace={workspace} /></div>
                                : <div><CapacityManagement preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} workspace={workspace} /></div>}</div> : null}
                        {selectedDashboard === 'Remediation' ?
                            <div><Remediation preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'Bot' ?
                            <div> {config.URL.includes(config.unilever) ? <div><BotPerformanceULL preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} workspace={workspace} /></div>
                                : <div><BotPerformance preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} workspace={workspace} /></div>}</div> : null}
                        {selectedDashboard === 'SchedulingEfficiency' ?
                            <div> {config.URL.includes(config.unilever) ? <div><AutomationSchedulingEfficiency timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} workspace={workspace} /></div>
                                : <div><SchedulingEfficiency preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} workspace={workspace} /></div>}</div> : null}
                        {selectedDashboard === 'TrustIndex' ?
                            <div> {config.URL.includes(config.unilever) ? <div><ULLAutomationTrustIndex preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} workspace={workspace} /></div> :
                                <div><AutomationTrustIndex preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} workspace={workspace} /></div>}</div> : null}
                        {selectedDashboard === 'ProductivityMetrics' ?
                            <div><ProductivityMetrics preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'ServiceDeskTriagePerformance' ?
                            <div><Juniper preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'BusinessViewValueRealization' ?
                            <div><BusinessViewValueRealization preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'Bpmn' ?
                            <div><BpmnDiagram preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'AutomationBusinessCatalogue' ?
                            <div><AutomationBusiness preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} workspace={workspace} selectedKpi={selectedKpi} /></div> : null}
                        {selectedDashboard === 'UsageStats' ?
                            <div><UsageStats preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} workspace={workspace} selectedKpi={selectedKpi} /></div> : null}
                    </div>
                    :
                    <div></div>
                }
            </div>
        </div>
    );
};


export default HeaderPanel;
